////changed due to package upgrade
import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Grid,
  Button,
  Stack,
  useMediaQuery,
  alpha,
} from '@mui/material';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

const customScrollbarStyle = {
  // Define the styles for the scrollbar
  '&::-webkit-scrollbar': {
    width: '8px',
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#44444461', // Lighter black color
    borderRadius: '8px', // Curved border
  },

  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#666', // Lighter black color on hover
  },
};

const ViewWaiverLog = ({
  isOpen,
  onClose,
  waiverLogData,
  verbiageSettings,
}) => {
  const companyTheme = CompanyTheme();
  const isMobile = useMediaQuery('(max-width: 755px)');
  // Function to remove HTML tags from the content
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        className='p-popup'
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: '8px',
          boxShadow: 24,
          p: 4,
          minWidth: 300,
          maxHeight: 'calc(100vh - 200px)',
          overflow: 'auto',
          overflowWrap: 'break-word',
          ...customScrollbarStyle,
        }}
      >
        <Formik>
          <Form>
            <Typography variant='h4' color={companyTheme.primary.main}>
              View {verbiageSettings?.waiver_name || 'Waiver'} Log
            </Typography>

            <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Grid container spacing={2}>
                <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='left'>
                        <span>Participant</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='center'>
                        <span>:</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                    <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                      <Box
                        display='flex'
                        justifyContent='flex-start'
                        className='wordbreak'
                      >
                        <span style={{ textTransform: 'capitalize' }}>
                          {waiverLogData.first_name || '-'}{' '}
                          {waiverLogData.last_name || ''}
                        </span>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Grid container spacing={2}>
                <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='left'>
                        <span>Signed By</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='center'>
                        <span>:</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                    <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                      <Box
                        display='flex'
                        justifyContent='flex-start'
                        className='wordbreak'
                      >
                        <span style={{ textTransform: 'capitalize' }}>
                          {waiverLogData.signed_by_firstName || '-'}{' '}
                          {waiverLogData.signed_by_lastName || '-'}
                        </span>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Grid container spacing={2}>
                <Grid size={{ xs: 4 }}sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='left'>
                        <span>Email</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='center'>
                        <span>:</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }} sx={{ my: 2 }}>
                    <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                      <Box
                        display='flex'
                        justifyContent='flex-start'
                        className='wordbreak'
                      >
                        <span style={{ textTransform: 'capitalize' }}>
                          {waiverLogData.email}
                        </span>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Grid container spacing={2}>
                <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='left'>
                        <span>Title</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='center'>
                        <span>:</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }} sx={{ my: 2 }}>
                    <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                      <Box
                        display='flex'
                        justifyContent='flex-start'
                        className='wordbreak'
                      >
                        <span style={{ textTransform: 'capitalize' }}>
                          {waiverLogData.waiver_name}
                        </span>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Stack spacing={1}>
                <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box
                        display='flex'
                        justifyContent='left'
                        sx={{ marginBottom: 3 }}
                      >
                        <span>Text</span>
                      </Box>
                    </Typography>
                  </Grid>

                  <Grid size={{ xs: 12 }} sx={{ my: 2 }}>
                    <Box
                      display='flex'
                      justifyContent='flex-start'
                      className='wordbreak'
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            waiverLogData?.waiver_description ||
                              'No description found',
                          ),
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid size={{ xs: 12 }} sx={{ my: 2 }}>
                    <Typography
                      variant='h4'
                      sx={{
                        fontWeight: 'normal',
                        wordBreak: 'break-all',
                        padding: '10px',
                      }}
                    >
                      <Box
                        display='flex'
                        justifyContent='flex-start'
                        className='wordbreak'
                      >
                        <span>
                          This is a legally binding document. I am{' '}
                          <b>{waiverLogData?.signer_name || ''}</b>, and I agree to be
                          legally bound by this digital signature. I understand
                          that I have the option to sign a paper copy instead.
                        </span>
                      </Box>
                    </Typography>
                  </Grid>
                </Stack>
              </Grid>
              <Grid size={{ xs: 4 }}>
                <Box display='flex' justifyContent='flex-end'>
                  <Button
                    variant='outlined'
                    color='primary'
                    onClick={onClose}
                    size={isMobile ? 'small' : 'medium'}
                    sx={{
                      borderColor: companyTheme
                        ? companyTheme.primary.main
                        : '#2196f3',
                      '&:hover': {
                        borderColor: companyTheme
                          ? alpha(companyTheme.primary.main, 0.8)
                          : alpha('#2196f3', 0.8),
                      },
                      color: companyTheme
                        ? companyTheme.primary.main
                        : '#2196f3',
                    }}
                  >
                    Close
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Form>
        </Formik>
      </Box>
    </Modal>
  );
};

export default ViewWaiverLog;

ViewWaiverLog.propTypes = {
  waiverLogData: PropTypes.array,
  verbiageSettings: PropTypes.object,
  isOpen: PropTypes.func,
  onClose: PropTypes.func,
};
